import React from 'react';
import { reportingOp } from 'store/ducks/Reportings';

export const sheetTitles = [
  'b_02.03',
  'b_01.03',
  'b_03.01',
  'b_03.03',
  'b_04.01',
  'b_01.01',
  'b_01.02',
  'b_02.01',
  'b_02.02',
  'b_03.02',
  'b_05.01',
  'b_05.02',
  'b_06.01',
  'b_07.01',
];

export const sheetTitlesAdditional = [
  'ADDITIONAL_SHEETS.FUNCTIONS_WITH_OR_WITHOUT_ICT_SERVICES',
  'ADDITIONAL_SHEETS.FUNCTIONS_WITH_ICT_SERVICES',
  'ADDITIONAL_SHEETS.ICT_SERVICES_NOT_LINKED_TO_FUNCTIONS',
  'ADDITIONAL_SHEETS.INFORMATION_ASSETS_DATA',
  'ADDITIONAL_SHEETS.FUNCTIONS',
  'ADDITIONAL_SHEETS.THIRD_PARTY_SERVICE_PROVIDER',
  'ADDITIONAL_SHEETS.ICT_SERVICES',
  'ADDITIONAL_SHEETS.ICT_SYSTEMS',
  'ADDITIONAL_SHEETS.CERTIFICATES_OF_FUNCTIONS',
  'ADDITIONAL_SHEETS.CERTIFICATES_OF_ICT_SERVICES',
  'ADDITIONAL_SHEETS.CERTIFICATES_OF_ICT_SYSTEMS_BY_FUNCTIONS',
  'ADDITIONAL_SHEETS.CERTIFICATES_OF_ICT_SYSTEMS_BY_ICT_SERVICES',
  'ADDITIONAL_SHEETS.ENTITIES_BY_FINANCIAL_LEI',
];

export const columnHeadersMap = [
  [
    '0010 - Contractual arrangement reference number',
    '0020 - Contractual arrangement linked to the contractual arrangement referred in B.02.03.0010',
    'Selected Date',
    'Name of the financial entity',
  ],
  [
    '0010 - Identification code of the branch',
    '0020 - LEI of the financial entity head office of the branch',
    '0030 - Name of the branch',
    '0040 - Country of the branch',
    'Selected Date',
    'Name of the financial entity',
  ],
  [
    '0010 - Contractual arrangement reference number',
    '0020 - LEI of the entity signing the contractual arrangement',
    'Selected Date',
    'Name of the financial entity',
  ],
  [
    '0010 - Contractual arrangement reference number',
    '0020 - LEI of the financial entity providing ICT services',
    'Selected Date',
    'Name of the financial entity',
  ],
  [
    '0010 - Contractual arrangement reference number',
    '0020 - LEI of the financial entity making use of the ICT service(s)',
    '0030 - Nature of the financial entity making use of the ICT service(s)',
    '0040 - Identification code of the branch',
    'Selected Date',
    'Name of the financial entity',
  ],
  [
    '0010 - LEI of the financial entity maintaining the register of information',
    '0020 - Name of the financial entity',
    '0030 - Country of the entity',
    '0040 - Type of entity',
    '0050 - Competent Authority',
    '0060 - Date of the reporting',
    'Selected Date',
  ],
  [
    '0010 - LEI of the financial entity',
    '0020 - Name of the entity',
    '0030 - Country of the financial entity',
    '0040 - Type of financial entity',
    '0050 - Hierarchy of the financial entity within the group (where applicable)',
    '0060 - LEI of the direct parent undertaking of the entity',
    '0070 - Date of last update',
    '0080 - Date of integration in the Register of information',
    '0090 - Date of deletion in the Register of information',
    '0100 - Currency',
    '0110 - Value of total assets of the financial entity',
    'Selected Date',
  ],
  [
    '0010 - Contractual arrangement reference number',
    '0020 - Type of contractual arrangement',
    '0030 - Overarching contractual arrangement reference number',
    '0040 - Currency of the amount reported in B.02.01.0050',
    '0050 - Annual expense or estimated cost of the contractual arrangement for the past year',
    'Selected Date',
    'Name of the financial entity',
  ],
  [
    '0010 - Contractual arrangement reference number',
    '0020 - LEI of the financial entity making use of the ICT service(s)',
    '0030 - Identification code of the ICT third-party service provider',
    '0040 - Type of code to identify the ICT third-party service provider',
    '0050 - Function identifier',
    '0060 - Type of ICT services',
    '0070 - Start date of the contractual arrangement',
    '0080 - End date of the contractual arrangement',
    '0090 - Reason of the termination or ending of the contractual arrangement',
    '0100 - Notice period for the financial entity making use of the ICT service(s)',
    '0110 - Notice period for the ICT third-party service provider',
    '0120 - Country of the governing law of the contractual arrangement',
    '0130 - Country of provision of the ICT services',
    '0140 - Storage of data',
    '0150 - Location of the data at rest (storage)',
    '0160 - Location of management of the data (processing)',
    '0170 - Sensitiveness of the data stored by the ICT third-party service provider',
    '0180 - Level of reliance on the ICT service supporting the critical or important function.',
    'Selected Date',
    'Name of the financial entity',
  ],
  [
    '0010 - Contractual arrangement reference number',
    '0020 - Identification code of ICT third-party service provider',
    '0030 - Type of code to identify the ICT third-party service provider',
    'Selected Date',
    'Name of the financial entity',
  ],
  [
    '0010 - Identification code of ICT third-party service provider',
    '0020 - Type of code to identify the ICT third-party service provider',
    '0030 - Additional identification code of ICT third-party service provider',
    '0040 - Type of additional identification code of the ICT third-party service provider',
    '0050 - Legal name of the ICT third-party service provider',
    '0060 - Name of the ICT third-party service provider in Latin alphabet',
    '0070 - Type of person of the ICT third-party service provider',
    '0080 - Country of the ICT third-party service provider’s headquarters',
    '0090 - Currency of the amount reported in RT.05.01.0070',
    '0100 - Total annual expense or estimated cost of the ICT third-party service provider',
    '0110 - Identification code of the ICT third-party service provider’s ultimate parent undertaking',
    '0120 - Type of code to identify the ICT third-party service provider’s ultimate parent undertaking',
    'Selected Date',
    'Name of the financial entity',
  ],
  [
    '0010 - Contractual arrangement reference number',
    '0020 - Type of ICT services',
    '0030 - Identification code of the ICT third-party service provider',
    '0040 - Type of code to identify the ICT third-party service provider',
    '0050 - Rank',
    '0060 - Identification code of the recipient of sub-contracted ICT services',
    '0070 - Type of code to identify the recipient of sub-contracted ICT services',
    'Selected Date',
    'Name of the financial entity',
  ],
  [
    '0010 - Function Identifier',
    '0020 - Licenced activity',
    '0030 - Function name',
    '0040 - LEI of the financial entity',
    '0050 - Criticality or importance assessment',
    '0060 - Reasons for criticality or importance',
    '0070 - Date of the last assessment of criticality or importance',
    '0080 - Recovery time objective of the function',
    '0090 - Recovery point objective of the function',
    '0100 - Impact of discontinuing the function',
    'Selected Date',
    'Name of the financial entity',
  ],
  [
    '0010 - Contractual arrangement reference number',
    '0020 - Identification code of the ICT third-party service provider',
    '0030 - Type of code to identify the ICT third-party service provider',
    '0040 - Type of ICT services',
    '0050 - Substitutability of the ICT third-party service provider',
    '0060 - Reason if the ICT third-party service provider is considered not substitutable or difficult to be substitutable',
    '0070 - Date of the last audit on the ICT third-party service provider',
    '0080 - Existence of an exit plan',
    '0090 - Possibility of reintegration of the contracted ICT service',
    '0100 - Impact of discontinuing the ICT services',
    '0110 - Are there alternative ICT third-party service providers identified?',
    '0120 - Identification of alternative ICT TPP',
    'Selected Date',
    'Name of the financial entity',
  ],
];

export const tableData = [
  {
    title: 'b_01.01',
    description: 'Entity maintaining the register of information',
  },
  {
    title: 'b_01.02',
    description:
      'List of entities within the scope of the register of information',
  },
  { title: 'b_01.03', description: 'List of branches' },
  {
    title: 'b_02.01',
    description: 'Contractual arrangements – General information',
  },
  {
    title: 'b_02.02',
    description: 'Contractual arrangements – Specific information',
  },
  {
    title: 'b_02.03',
    description: 'List of intra-group contractual arrangements',
  },
  {
    title: 'b_03.01',
    description:
      'Entities signing the Contractual arrangements for receiving ICT service(s) or on behalf of the entities making use of the ICT service(s)',
  },
  {
    title: 'b_03.02',
    description:
      'ICT third-party service providers signing the contractual arrangements for providing ICT service(s)',
  },
  {
    title: 'b_03.03',
    description:
      'Entities signing the Contractual arrangements for providing ICT service(s) to other entity within the scope of consolidation ',
  },
  {
    title: 'b_04.01',
    description: 'Financial entities making use of the ICT services',
  },
  { title: 'b_05.01', description: 'ICT third-party service provider' },
  { title: 'b_05.02', description: 'ICT service supply chains' },
  { title: 'b_06.01', description: 'Functions identification' },
  { title: 'b_07.01', description: 'Assessment of the ICT services' },
  {
    title: 'b_99.01',
    description:
      'Terminology used by financial entities using the ICT services',
  },
];

export interface AdditionalReportItem {
  titleKey: string;
  descriptionKey: string;
}

export const getTableDataAdditional = (t: any) => [
  {
    title: t('ADDITIONAL_SHEETS.FUNCTIONS_WITH_OR_WITHOUT_ICT_SERVICES'),
    description: '',
  },
  {
    title: t('ADDITIONAL_SHEETS.FUNCTIONS_WITH_ICT_SERVICES'),
    description: '',
  },
  {
    title: t('ADDITIONAL_SHEETS.ICT_SERVICES_NOT_LINKED_TO_FUNCTIONS'),
    description: '',
  },
  {
    title: t('ADDITIONAL_SHEETS.INFORMATION_ASSETS_DATA'),
    description: '',
  },
  {
    title: t('ADDITIONAL_SHEETS.FUNCTIONS'),
    description: '',
  },
  {
    title: t('ADDITIONAL_SHEETS.THIRD_PARTY_SERVICE_PROVIDER'),
    description: '',
  },
  {
    title: t('ADDITIONAL_SHEETS.ICT_SERVICES'),
    description: '',
  },
  {
    title: t('ADDITIONAL_SHEETS.ICT_SYSTEMS'),
    description: '',
  },
  {
    title: t('ADDITIONAL_SHEETS.CERTIFICATES_OF_FUNCTIONS'),
    description: '',
  },
  {
    title: t('ADDITIONAL_SHEETS.CERTIFICATES_OF_ICT_SERVICES'),
    description: '',
  },
  {
    title: t('ADDITIONAL_SHEETS.CERTIFICATES_OF_ICT_SYSTEMS_BY_FUNCTIONS'),
    description: '',
  },
  {
    title: t('ADDITIONAL_SHEETS.CERTIFICATES_OF_ICT_SYSTEMS_BY_ICT_SERVICES'),
    description: '',
  },
  {
    title: t('ADDITIONAL_SHEETS.ENTITIES_BY_FINANCIAL_LEI'),
    description: '',
  },
];

export const tableDataArticle8 = [
  {
    title: 'Roles and Responsibilities',
    description: '',
  },
  {
    title: 'ICT exposure function details',
    description: '',
  },
  {
    title: 'ICT exposure service details',
    description: '',
  },
  {
    title: 'Sources of ICT risk',
    description: '',
  },
  {
    title: 'Risk exposure to and from other financial entities',
    description: '',
  },
  {
    title: 'ICT Systems by function',
    description: '',
  },
  {
    title: 'ICT Systems by services',
    description: '',
  },
];

export const columnHeadersMapAdditional = [
  [
    'Name of the financial entity',
    'Function description',
    'Function level',
    'Function name',
    'ICT service level',
    'ICT service provider name',
  ],
  [
    'Name of the financial entity',
    'Function description',
    'Function level',
    'Function name',
    'ICT service level',
    'ICT service provider name',
  ],
  [
    'Name of the financial entity',
    'Function description',
    'Function level',
    'Function name',
    'ICT service level',
    'ICT service provider name',
  ],
  [
    'Description',
    'End date',
    'ICT system name',
    'Location of data at rest',
    'Location of data at management',
    'Sensitiveness',
    'Sensitiveness of data stored by ICT TPSP',
    'Start date',
  ],
  [
    'Alternatives exit',
    'Criticality assessment',
    'Date of last assessment',
    'Description',
    'Dora criticality',
    'End date',
    'Function identifier',
    'Function level',
    'Function name',
    'Impact of reintegration',
    'Licensed activity',
    'Possibility of reintegration',
    'Reasons for criticality',
    'Recovery point objective',
    'Recovery time objective',
    'Start date',
  ],
  [
    'Additional ICT service provider identification code',
    'Additional identification code type',
    'Alternative providers identified',
    'Alternative exit',
    'Criticality assessment',
    'Description',
    'Dora criticality',
    'Dora regulator criticality',
    'Dora regulator criticality label',
    'End date',
    'Entity nature',
    'Exit plan exists',
    'Headquarters country',
    'ICT service provider identification code',
    'ICT service provider lei',
    'Identification code type',
    'ISO code',
    'Last audit date',
    'Local regulator criticality',
    'Non subst reason',
    'Notice period',
    'Person type',
    'Possibility of reintegration',
    'Rank',
    'Recipient identification code',
    'Recipient identification type',
    'Start date',
    'Substitutability',
    'Substitutability of ICT provider',
    'Third party service provider legal name',
    'Third party service provider name',
    'Third party service provider code type',
    'Ultimate parent identification code',
    'Ultimate parent identification code type',
  ],
  [
    'Alternatives exit',
    'Auswahl services discount',
    'Contractual arrangement',
    'Country',
    'Criticality assessment',
    'End date',
    'Name of the financial entity',
    'Exit plan exists',
    'Function name',
    'ICT service description',
    'ICT service level',
    'ICT service type',
    'ICT services criticality',
    'Impact of discontinuing function',
    'Impact of discontinuing ICT services',
    'Level of reliance',
    'Level of supporting ICT serevice',
    'Local regulator criticality',
    'Notice period',
    'Possibility of reintegration',
    'Rank',
    'Recipient identification code',
    'Recipient identification type',
    'Start date',
    'Storage of data',
    'Substitutability of ICT provider',
    'Third party service provider name',
    'TPP code type',
  ],
  [
    'End date',
    'Function name',
    'ICT service description',
    'ICT system description',
    'ICT system name',
    'Start date',
  ],
];

export const columnOrderMapReports: Record<string, string[]> = {
  'b_01.01': [
    'lei_entity',
    'entity_name',
    'iso_code',
    'entity_type',
    'competent_authority',
    'reporting_date',
    'date',
  ],

  'b_01.02': [
    'lei_entity',
    'entity_name',
    'country_name',
    'entity_type',
    'hierarchy_in_group',
    'parent_lei',
    'date_of_last_update',
    'integration_date',
    'deletion_date',
    'currency',
    'total_assets',
    'date',
  ],

  'b_01.03': [
    'branch_identification_code',
    'head_office_lei',
    'branch_name',
    'iso_code',
    'date',
    'entity_name',
  ],

  'b_02.01': [
    'arrangement_reference_number',
    'contract_type',
    'overarching_reference_number',
    'currency',
    'annual_expense',
    'date',
    'entity_name',
  ],
  'b_02.02': [
    'Contractual arrangement ref. number',
    'LEI of the entity using ICT service',
    'Type of ICT service provider code',
    'Type of ICT service provider code',
    'Function identifier',
    'Type of ICT services',
    'Start date',
    'End date',
    'Termination reason',
    'Entity notice period',
    'Provider notice period',
    'Governing law country',
    'Country of ICT services',
    'Storage of data',
    'Data location (storage)',
    'Data location (processing)',
    'Data sensitiveness',
    'Level of reliance',
    'date',
    'entity_name',
  ],
  'b_02.03': [
    'arrangement_reference_number',
    'linked_contractual_arrangement',
    'date',
    'entity_name',
  ],
  'b_03.01': ['arrangement_reference_number', '', 'date', 'entity_name'],
  'b_03.02': [
    'Contractual arrangement ref. number',
    'ICT service provider code',
    'Type of ICT service provider code',
    'date',
    'entity_name',
  ],
  'b_03.03': ['arrangement_reference_number', 'lei_of_entity'],
  'b_04.01': [
    'arrangement_reference_number',
    'lei_entity_making_use_ICT_service',
    'Nature of entity',
    'branch_identification_code',
    'date',
    'entity_name',
  ],
  'b_05.01': [
    'ICT service provider code',
    'Type of ICT service provider code',
    'Additional identification code of ICT third-party service provi',
    'Type of additional identification code to identify the ICT thir',
    'Legal name of the ICT third- party service provider',
    'Name of ICT service provider',
    'Type of person',
    'Headquarters country',
    'Reported currency',
    'Total annual expense',
    'Ultimate parent code',
    'Type of ultimate parent code',
    'date',
    'entity_name',
  ],
  'b_05.02': [
    'Contractual arrangement ref. number',
    'Type of ICT services',
    'ICT service provider code',
    'Type of ICT service provider code',
    'Rank',
    'Recipient ID code',
    'Recipient ID type',
    'date',
    'entity_name',
  ],
  'b_06.01': [
    'Function identifier',
    'Licenced activity',
    'Function name',
    'LEI of the financial entity',
    'Criticality assessment',
    'Reasons for criticality',
    'Date of the last assessment of criticality',
    'Recovery time objective of the function',
    'Recovery point objective of the function',
    'Impact of discontinuing the function',
    'date',
    'entity_name',
  ],
  'b_07.01': [
    'Arrangement reference number',
    'ICT service provider identification code',
    'Type of ICT service provider code',
    'Type of ICT services',
    'Substitutability of ICT provider',
    'Reason for non-substitutability',
    'Date of last audit',
    'Exit plan exists',
    'Reintegration possible',
    'Impact of discontinuing ICT services',
    'Alternative providers identified',
    'Alternative ICT TPP identification',
    'date',
    'entity_name',
  ],
};

export const columnOrderMapAdditionalReports: Record<string, string[]> = {
  'Functions with or without ICT Services': [
    'entity_name',
    'function_description',
    'function_level',
    'function_name',
    'ict_service_level',
    'ict_service_provider_name',
  ],
  'Functions with ICT services': [
    'entity_name',
    'function_description',
    'function_level',
    'function_name',
    'ict_service_level',
    'ict_service_provider_name',
  ],
  'ICT Services not linked to Functions': [
    'entity_name',
    'function_description',
    'function_level',
    'function_name',
    'ict_service_level',
    'ict_service_provider_name',
  ],
  'Information Assets (Data)': [
    'description',
    'end_date',
    'ict_system_name',
    'location_of_data_at_rest',
    'location_of_data_management',
    'sensitiveness',
    'sensitiveness_of_data_stored_by_ict_tpsp',
    'start_date',
  ],
  Functions: [
    'alternatives_exit',
    'criticality_assessment',
    'date_of_last_assessment',
    'description',
    'dora_criticality',
    'end_date',
    'function_identifier',
    'function_level',
    'function_name',
    'impact_of_discontinuing',
    'licensed_activity',
    'possibility_of_reintegration',
    'reasons_for_criticality',
    'recovery_point_objective',
    'recovery_time_objective',
    'start_date',
  ],
  'Third Party Service Provider': [
    'add_ict_service_provider_identification_code',
    'add_identification_code_type',
    'alternative_providers_identified',
    'alternatives_exit',
    'criticality_assessment',
    'description',
    'dora_criticality',
    'dora_regulator_criticality',
    'dora_regulator_criticality_label',
    'end_date',
    'entity_nature',
    'exit_plan_exists',
    'headquarters_country',
    'ict_service_provider_identification_code',
    'ict_service_provider_lei',
    'identification_code_type',
    'iso_code',
    'last_audit_date',
    'local_regulator_criticality',
    'non_subst_reason',
    'notice_period',
    'person_type',
    'possibility_of_reintegration',
    'rank',
    'recipient_identification_code',
    'recipient_identification_type',
    'start_date',
    'substitutability',
    'substitutability_of_ict_provider',
    'third_party_service_provider_legal_name',
    'third_party_service_provider_name',
    'tpp_code_type',
    'ultimate_parent_identification_code',
    'ultimate_parent_identification_code_type',
  ],
  'ICT Services': [
    'alternatives_exit',
    'auswahl_services_discount',
    'contractual_arrangement',
    'country',
    'criticality_assessment',
    'end_date',
    'entity_name',
    'exit_plan_exists',
    'function_name',
    'ict_service_description',
    'ict_service_level',
    'ict_service_type',
    'ict_services_criticality',
    'impact_of_discontinuing_function',
    'impact_of_discontinuing_ict_services',
    'level_of_reliance',
    'level_of_supporting_ict_service',
    'local_regulator_criticality',
    'notice_period',
    'possibility_of_reintegration',
    'rank',
    'recipient_identification_code',
    'recipient_identification_type',
    'start_date',
    'storage_of_data',
    'substitutability_of_ict_provider',
    'third_party_service_provider_name',
    'tpp_code_type',
  ],
  'ICT Systems': [
    'end_date',
    'function_name',
    'ict_service_description',
    'ict_system_description',
    'ict_system_name',
    'start_date',
  ],
};

export const tableMappings = [
  { tableNumber: 'b_01.03', fetchFn: reportingOp.fetchBranches },
  {
    tableNumber: 'b_02.03',
    fetchFn: reportingOp.fetchEntityContractualArrangements,
  },
  {
    tableNumber: 'b_03.01',
    fetchFn: reportingOp.fetchContractualArrangementsLei,
  },
  {
    tableNumber: 'b_03.03',
    fetchFn: reportingOp.fetchContractualArrangementsICT,
  },
  {
    tableNumber: 'b_04.01',
    fetchFn: reportingOp.fetchContractualArrangementsICTUse,
  },
  { tableNumber: 'b_01.01', fetchFn: reportingOp.fetchRT0101 },
  { tableNumber: 'b_01.02', fetchFn: reportingOp.fetchRT0102 },
  { tableNumber: 'b_02.01', fetchFn: reportingOp.fetchRT0201 },
  { tableNumber: 'b_02.02', fetchFn: reportingOp.fetchRT0202 },
  { tableNumber: 'b_03.02', fetchFn: reportingOp.fetchRT0302 },
  { tableNumber: 'b_05.01', fetchFn: reportingOp.fetchRT0501 },
  { tableNumber: 'b_05.02', fetchFn: reportingOp.fetchRT0502 },
  { tableNumber: 'b_06.01', fetchFn: reportingOp.fetchRT0601 },
  { tableNumber: 'b_07.01', fetchFn: reportingOp.fetchRT0701 },
];
